// リーグブランディング設定（バナー画像）のフォーム挙動
// 送信ボタンのdisabled制御は league.js の checkRequiredFields() が管理しているため、
// このファイルからは絶対に触らない（競合すると送信できなくなる）

(function () {
  'use strict';

  var ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  $(document).on('turbolinks:load', function () {
    var $section = $('.branding-section');
    if (!$section.length) return;

    var isLocked = $section.hasClass('branding-section--locked');
    var maxFileSize = Number($section.data('max-file-size')) || 0;
    var i18n = {};
    try {
      i18n = JSON.parse($section.attr('data-i18n') || '{}');
    } catch (e) {
      console.error('branding-section i18n parse failed:', e);
    }

    // ===== バナー画像 =====
    var $drop = $section.find('.branding-section__drop');
    var $fileInput = $section.find('.js-branding-banner-input');
    var $filePreview = $section.find('.js-branding-banner-preview');
    var $filePreviewWrap = $section.find('.branding-section__preview');
    var $fileError = $section.find('.js-branding-banner-error');
    var $removeBannerField = $section.find('.js-branding-remove-banner');
    var $bannerRemoveBtn = $section.find('.js-branding-banner-remove');
    var $layoutField = $section.find('.js-branding-layout');

    // ヘッダーレイアウトはバナーが設定されているときだけ選べる
    function setLayoutEnabled(enabled) {
      $layoutField.toggleClass('is-disabled', !enabled);
    }

    // 初期状態（サーバーから返ってきた表示状態）を保持し、無効なファイル選択時に復元する
    var initialBannerSrc = $filePreview.attr('src') || '';
    var initialPreviewVisible = $filePreviewWrap.hasClass('is-visible');

    function resetBannerToInitial() {
      $filePreview.attr('src', initialBannerSrc);
      $filePreviewWrap.toggleClass('is-visible', initialPreviewVisible);
      $drop.toggleClass('branding-section__drop--hidden', initialPreviewVisible);
      setLayoutEnabled(initialPreviewVisible);
    }

    if (!isLocked) {
      $drop.on('click', function () {
        $fileInput.trigger('click');
      });

      $drop.on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          $fileInput.trigger('click');
        }
      });
    }

    $fileInput.on('change', function () {
      var file = this.files && this.files[0];
      $fileError.text('');

      if (!file) return;

      if (ALLOWED_IMAGE_TYPES.indexOf(file.type) === -1) {
        $fileError.text(i18n.fileInvalidFormat || '');
        $fileInput.val('');
        resetBannerToInitial();
        return;
      }

      if (maxFileSize > 0 && file.size > maxFileSize) {
        $fileError.text(i18n.fileTooLarge || '');
        $fileInput.val('');
        resetBannerToInitial();
        return;
      }

      $filePreview.attr('src', URL.createObjectURL(file));
      $filePreviewWrap.addClass('is-visible');
      $drop.addClass('branding-section__drop--hidden');
      $removeBannerField.val('0');
      setLayoutEnabled(true);
    });

    $bannerRemoveBtn.on('click', function () {
      $filePreviewWrap.removeClass('is-visible');
      $drop.removeClass('branding-section__drop--hidden');
      $fileInput.val('');
      $removeBannerField.val('1');
      setLayoutEnabled(false);
    });
  });
})();
